<header class="background-header classic-background"></header>
<section class="main-side-nav" id="mainSideNav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent events-log-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Events Log'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Events Log</h1>
            </div>
        </section>
        <!-- Search -->
        <!--    <section class="all-users-line-presentation">-->
        <!--      <div class="search-section">-->
        <!--        <label>Filter</label>-->
        <!--        <input type="text" class="dashboard-input" [(ngModel)]="filter" placeholder="filter" style="width:500px !important;">-->
        <!--        <input type="button" class="btn btn-primary search-btn" value="Filter" (click)="refresh()">-->
        <!--      </div>-->
        <!--      <div class="search-section" *ngIf="eventList && sectionList">-->
        <!--        <label>Events<select>-->
        <!--          <option *ngFor="let val of eventList">{{val}}</option>-->
        <!--        </select></label>-->
        <!--        <label>Sections<select>-->
        <!--          <option *ngFor="let val2 of sectionList">{{val2}}</option>-->
        <!--        </select></label>-->
        <!--      </div>-->
        <!--    </section>-->
        <!--    &lt;!&ndash; Table Data &ndash;&gt;-->
        <!--    <div *ngIf="dataLoaded">-->
        <!--        <app-event-log-window [rows]="rows" [columns]="columns"></app-event-log-window>-->
        <!--    </div>-->

        <app-events-pane-container [uid]="'events-log-container'">
          <app-events-pane class="chart-type-item" [displayType]="'pie-chart'"></app-events-pane>
          <app-events-pane class="chart-type-item" [displayType]="'bar-chart'"></app-events-pane>
          <app-events-pane class="chart-type-item" [displayType]="'line-chart'"></app-events-pane>
          <app-events-pane fullWidth [displayType]="'table'"></app-events-pane>
        </app-events-pane-container>

        <!--    <section class="all-users-data">-->
        <!--      <div class="table-responsive admin-dashboard-table" *ngIf="dataLoaded">-->
        <!--        <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="rows" [columnDefs]="columns"></ag-grid-angular>-->
        <!--      </div>-->
        <!--    </section>-->
    </section>
</section>
